import { render } from "./KTDataTable.vue?vue&type=template&id=8fbc7166&ts=true"
import script from "./KTDataTable.vue?vue&type=script&lang=ts"
export * from "./KTDataTable.vue?vue&type=script&lang=ts"

import "./KTDataTable.vue?vue&type=style&index=0&id=8fbc7166&lang=scss"

import exportComponent from "/var/www/rewards/runners/admin/root/reward-admin/reward-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__